import LiveArenaPage from '../components/LiveArena/LiveArenaPage';

export default LiveArenaPage;
